module.exports = __webpack_public_path__ + "static/media/Tutorial-RateReviews.a822968b.pdf";